import Search from '@acri-tools/react-tools/components/Search/Search';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import { searchParamsQuery } from '@acri-tools/react-tools/utils/query';
import request from '@acri-tools/react-tools/utils/request';
import { Component } from 'react';
import { API_URL } from '../../../../utils/config';
import UpdateContact from '../../../../components/UpdateContact/UpdateContact';

interface Props {
    // REDUX
}
interface State {
    count: number
    searchParams: any
    entities?: Array<any>
    filters: any
    filterEnabled: boolean

    loading?: boolean

    message?: string
    messageType?: string

    // update
    entity?: any
    loading_entity: boolean

    updateLoading: boolean
    updateMessage: string
    updateMessageType: string
}


class SearchITContacts extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            count: 0,
            searchParams: {
                search: '',
                offset: '0',
                limit: '10',

                orderby: 'id',
                orderbyDirection: 'desc',
            },
            filters: {
                "name": { active: true },
                "email": { active: true },
            },
            filterEnabled: true,

            // update
            loading_entity: false,

            updateLoading: false,
            updateMessage: '',
            updateMessageType: 'error',
        }
    }

    componentDidMount() {
        this.search();
    }

    render() {
        return (
            <>
                <div className="panel panel-full">
                    <h1 className="title-1">Search Contacts</h1>
                    <div className="subtitle-1">Search contacts using the following criteria</div>
                    <br />


                    <Search orderby={['name']} count={this.state.count}
                        filters={this.state.filters} searchParams={this.state.searchParams} search={this.search} >
                        <div className="results">
                            <div className="results-table">
                                <table className="dark">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Type</th>
                                            <th>Options</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.entities &&
                                            this.state.entities.map((entity: any, idx: number) => (
                                                <tr key={idx}>
                                                    <td>{entity.name}</td>
                                                    <td>{entity.email}</td>
                                                    <td>{entity.type}</td>
                                                    <td>
                                                        <div className="search-operations">
                                                            <div className="search-operation custom-button inverted alt icon-only"
                                                                onClick={() => { this.view(entity) }}>
                                                                <i className="fas fa-eye" />
                                                                <div className="tooltip">
                                                                    <div className="tooltip-content">
                                                                        VIEW
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="search-operation custom-button inverted red alt icon-only"
                                                                onClick={() => {
                                                                    this.delete(entity)
                                                                }}
                                                            >
                                                                <i className="fas fa-times" />
                                                                <div className="tooltip">
                                                                    <div className="tooltip-content">
                                                                        DELETE
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Search>

                </div>

                {
                    this.state.loading_entity ?
                        <div className="panel panel-big">
                            <div className="centered">
                                <Spinner white />
                            </div>
                        </div>
                        :
                        this.state.entity &&
                        <div className="panel panel-big">

                            <h1 className="title-1">Update contact</h1>
                            <div className="subtitle-1">Update the selected contact</div>
                            <br />
                            <UpdateContact
                                contact={this.state.entity}
                                onUpdate={() => { this.search() }}
                            />
                        </div>
                }
            </>
        );
    }


    search = async () => {
        this.setState({ loading: true });
        try {
            let res = await request(`${API_URL}/api/v1/contacts`, {
                method: 'get',
                params: {
                    ...searchParamsQuery(this.state.searchParams, this.state.filters),
                    count: true
                },
            })

            this.setState({ entities: res.data.value, count: res.data.count });
        }
        catch (e: any) {
            axiosErrorHandler(e, {
                functionName: 'search',
                requestName: 'search_contacts',
            })
            this.setState({
                loading: false,
                message: e.response && e.response.data && e.response.data.error ? e.response.data.error : 'An error has occured.',
                messageType: 'error'
            })
        }
        finally {
            this.setState({ loading: false })
        }
    }

    delete = (entity: any) => {
        if (window.confirm(`Are you sure you want to delete contacts '${entity.name}' ?`)) {
            request(`${API_URL}/api/v1/contacts/${entity.id}`, {
                method: 'delete',
            })
                .then((res: any) => {
                    this.search();
                })
                .catch(e => {
                    axiosErrorHandler(e, {
                        functionName: 'delete',
                        requestName: 'delete_contacts',
                    })
                })
        }
    }

    view = async (e: any) => {
        this.setState({ loading_entity: true })
        try {
            let res = await request(`${API_URL}/api/v1/contacts/${e.id}`, {
                method: 'get'
            })
            let entity = res.data;
            this.setState({ entity, updateMessage: '' });
        }
        catch (e: any) {

            axiosErrorHandler(e, {
                functionName: 'view',
                requestName: 'view_contact',
            })
        }
        finally {
            this.setState({ loading_entity: false })
        }
    }
};


export default SearchITContacts;
